import * as echarts from 'echarts'
import VabChart from 'vue-echarts'

VabChart.graphic = echarts.graphic
export default VabChart
